export default "__VITE_ASSET__Blzuc2Y$__"